import { useNavigate } from "react-router-dom";
import { Activity } from "lucide-react";
import { Button } from "@/components/ui/button";

const DataIngestionTicker = () => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center gap-3 border-b border-border bg-muted/50 px-4 py-1.5 text-xs text-muted-foreground">
      <Activity className="h-3.5 w-3.5 text-primary shrink-0 animate-pulse" />
      <span>
        <span className="font-semibold text-foreground">Data ingestion status:</span>{" "}
        2,000 records ingested across 20 tables across 5 data sources in last 1 hour.{" "}
        <span className="text-foreground font-medium">(Total records: 100,000)</span>
      </span>
      <Button
        variant="outline"
        size="sm"
        className="h-6 px-2.5 text-xs shrink-0"
        onClick={() => navigate("/sync-monitor")}
      >
        Explore
      </Button>
    </div>
  );
};

export default DataIngestionTicker;
